import { dialog } from "./app";

(async () => {
  await dialog();
})();
